import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=d1566f5c&scoped=true&"
import script from "./BaseMenu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseMenu.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=d1566f5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1566f5c",
  null
  
)

export default component.exports